import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { useEffect, useState } from "react";
import { fetchData, toAbsoluteMedia } from "../api/api"; // adjust path if needed

import TestimonialClient1 from "../assets/images/client1.jpg";
import TestimonialClient2 from "../assets/images/client2.jpg";
import TestimonialClient3 from "../assets/images/client3.jpg";
import TestimonialClient4 from "../assets/images/client4.jpg";
import LeftArrow from "../assets/images/slider-left-arrow.svg";
import RightArrow from "../assets/images/slider-right-arrow.svg";

const FALLBACK_AVATARS = [
  TestimonialClient1,
  TestimonialClient2,
  TestimonialClient3,
  TestimonialClient4,
];

const TestimonialSlider = () => {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setErr("");
      try {
        const data = await fetchData("/review/list/"); // DRF trailing slash
        const mapped = (data || []).map((r, i) => ({
          title: r.title || "What They Said",
          message: r.content || "",
          name: r.client_name || "Anonymous",
          role: r.position_of_client || "",
          avatar:
            toAbsoluteMedia(r.client_image || "") ||
            FALLBACK_AVATARS[i % FALLBACK_AVATARS.length],
        }));
        if (!alive) return;
        setItems(mapped);
      } catch (e) {
        if (!alive) return;
        setErr("Failed to load testimonials.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const settings = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 1000,
    prevArrow: (
      <button type="button" className="slick-prev">
        <img src={LeftArrow} alt="slider-left-arrow" />
      </button>
    ),
    nextArrow: (
      <button type="button" className="slick-next">
        <img src={RightArrow} alt="slider-right-arrow" />
      </button>
    ),
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 1, slidesToScroll: 1, autoplay: true, arrows: false } },
      { breakpoint: 991,  settings: { slidesToShow: 1, slidesToScroll: 1, autoplay: true, arrows: false } },
    ],
  };

  return (
    <section className="section-six overflow-hidden">
      <div className="container">
        <p className="our-services" data-aos="fade-up">TESTIMONIALS</p>
        <h2 className="our-solution latest_project" data-aos="fade-down">What Our Clients Say.</h2>

        {loading && <p data-aos="fade-up">Loading testimonials…</p>}
        {!loading && err && <p data-aos="fade-up">{err}</p>}

        {!loading && !err && items.length > 0 && (
          <div className="testimonial_slider" data-aos="zoom-in-left">
            <Slider {...settings} className="slick-slide-home">
              {items.map((t, idx) => (
                <div key={idx}>
                  <div className="great-work-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 40 30" fill="none">
                      <path d="M11.9903 8.97047..." stroke="#FF7D61" strokeWidth="2" />
                    </svg>
                    <h3>{t.title}</h3>
                  </div>

                  <p className="posuere" style={{ marginRight: "10px" }}>
                    {t.message}
                  </p>

                  <svg className="slider-line" xmlns="http://www.w3.org/2000/svg" height="33" viewBox="0 0 630 33" fill="none">
                    <path d="M630 1H100L70 31V1H0" stroke="#909090" />
                  </svg>

                  <div className="client_details">
                    <img
                      className="testimonial_client_img"
                      width={100}
                      height={100}
                      src={t.avatar}
                      alt={t.name}
                      onError={(e) => (e.currentTarget.src = FALLBACK_AVATARS[idx % FALLBACK_AVATARS.length])}
                    />
                    <div>
                      <h3 className="client-name">{t.name}</h3>
                      {t.role && <p className="studio">{t.role}</p>}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        )}
      </div>
    </section>
  );
};

export default TestimonialSlider;
